import { createSearchString } from "components/navigation/SearchString";
import { getUrlHash } from "components/navigation/URL";
import type { Dayjs } from "dayjs";
import type {
  FormatterCallbackFunction,
  Point,
  PointOptionsObject,
  Series,
  SeriesClickEventObject,
  SeriesEventsOptionsObject,
  SeriesTooltipOptionsObject,
} from "highcharts";

export interface AssetRegisterItemScatterColumn extends PointOptionsObject {
  locationAddress?: string;
  assetPositionReference?: string;
  asset_position_id?: string;
  asset_id?: string;
  x?: number;
  y?: number;
}

export interface AssetRegisterItemScatterPoint extends Point {
  locationAddress?: string;
  assetPositionReference?: string;
  asset_position_id?: string;
  asset_id?: string;
  x: number;
  y?: number;
}

export interface AssetRegisterItemColumn extends PointOptionsObject {
  locationAddress?: string;
  assetPositionReference?: string;
  asset_position_id?: string;
  asset_id?: string;
  y?: number;
}

export interface AssetRegisterItemPoint extends Point {
  locationAddress?: string;
  assetPositionReference?: string;
  asset_position_id?: string;
  asset_id?: string;
  y?: number;
}

export interface AggregatedSeriesClickEventObject
  extends SeriesClickEventObject {
  point: AssetRegisterItemScatterPoint | AssetRegisterItemPoint;
}

export interface AggregatedChartsAmendedOptions {
  tooltip: SeriesTooltipOptionsObject & {
    pointFormatter: FormatterCallbackFunction<
      AssetRegisterItemScatterPoint | AssetRegisterItemPoint
    >;
  };
  events?: SeriesEventsOptionsObject & {
    click?: (this: Series, event: AggregatedSeriesClickEventObject) => void;
  };
}

export interface AggregatedDataItemClickHandlerProps {
  start_time: Dayjs;
  end_time: Dayjs;
  company_id: string;
  scheme_id: string;
}

export function aggregationDataItemClickHandler(
  props: AggregatedDataItemClickHandlerProps & { privacyMode: boolean },
) {
  return function (this: Series, event: AggregatedSeriesClickEventObject) {
    const { asset_position_id } = event.point;

    const url = `/admin/asset_register/asset_position/${asset_position_id}?${createSearchString(
      {
        startDatetime: props.start_time?.format(),
        endDatetime: props.end_time?.format(),
      },
    )}${getUrlHash(props.company_id, props.scheme_id, props.privacyMode)}`;
    window.open(url, "_blank");
  };
}
